module.exports = __webpack_public_path__ + "static/media/icon6-3.a992e970.png";